import { defaultBlockStyles } from "./blockStylesConfig"
import { BlockStyleType, BlockType } from "./types"

export const getStyles = (
  block: BlockType | null = null,
  blockStyles: BlockStyleType | null = null
): BlockStyleType => {
  // Merge with priority: default < block.style < blockStyles
  const merged: any = {
    ...defaultBlockStyles,
    ...(block && block.style ? block.style : {}),
    ...(blockStyles || {})
  }

  // Ensure required keys exist with valid object values
  if (
    !merged.selectedSettings ||
    typeof merged.selectedSettings !== "object" ||
    !Object.keys(merged.selectedSettings).length
  ) {
    merged.selectedSettings = defaultBlockStyles.selectedSettings
  }
  if (
    !merged.styleAttributes ||
    typeof merged.styleAttributes !== "object" ||
    !Object.keys(merged.styleAttributes).length
  ) {
    merged.styleAttributes = defaultBlockStyles.styleAttributes
  }

  // These shouldn't be saved on the server
  delete merged.styleOptions
  delete merged.__typename

  return merged as BlockStyleType
}
